import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { CarrierService } from "app/services/carrier.service";
import { CarrierDepotService } from "../service/carrier-depot.service";
import { DocumentsServiceService } from "app/services/documents-service.service";

@Component({
  selector: "app-carrier-depot-details",
  templateUrl: "./carrier-depot-details.component.html",
  styleUrls: ["./carrier-depot-details.component.scss"],
})
export class CarrierDepotDetailsComponent implements OnInit {
  @Input() carrierId;
  @Output() saved = new EventEmitter();
  isLoading:boolean;
  carrierDetails:any = [];
  branches:any = [];
  @Input() depotDetails:any;
  viewDocuments: any;
  pdfSrc: string;
  constructor(
    private _carrierInfo:CarrierService,
    private documentService: DocumentsServiceService,
  ) {
  }
  
  ngOnInit(): void {
    console.log('here')
    if(this.carrierId){
      this.getCarrierInfo();
      this.getCarrierExistingDocuments();
    } 
  }

  getCarrierInfo() {
    this.isLoading = true;
    this._carrierInfo
      .getCompanyDetailsById(this.carrierId)
      .subscribe((res: any) => {
        if (res) this.carrierDetails = res.Carrier;
        if (res && res.Branches) this.branches = res.Branches;
        this.isLoading = false;
      });
  }

  navigateToEdit() {
    
  }

  back() {
    this.saved.emit(true);
  }
  getCarrierExistingDocuments() {
    this.isLoading = true;
    this.documentService.getByCarrierId(this.carrierId).subscribe(
      (result:any) => {
        console.log(result);
        if(this.depotDetails.id_type_ind ==  1){
          this.viewDocuments = result.filter(x => x.notes === this.depotDetails.id_number);
          
        }
        if(this.depotDetails.id_type_ind == 2){
          this.viewDocuments = result.filter(x => x.notes === this.depotDetails.passport_number);
        }
        if (this.viewDocuments.length > 0) {
          // this.removeUploadedDocTypes();
        }
      },
      (error) => {
        this.viewDocuments = [];
  
        this.isLoading = false;
        // this.dialogService.addDialog(ErrorComponent, { title: 'Document Uploads', message: `Unable to retrieve carrier documents.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      }
    );
  }
  viewDoc(id, fileName) {

    id = fileName.substring(fileName.indexOf("#") + 1);
    this.pdfSrc = null;
    let ext = fileName.substring(fileName.length - 3, fileName.length);
    //console.log(ext);
    if (fileName.includes(".pdf")) {
      this.documentService.downloadpdf(id).subscribe((x) => {
        console.log(x);
  
        let objectURL = URL.createObjectURL(x);
        this.pdfSrc = objectURL;
  
        //alert(this.pdfSrc.toString());
        //this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        //console.log(this.pdfSrc)
        this.isLoading = false;
      });
      return;
    }

  }
}
